/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject} from '@angular/core';
import template from './print-line-item-list-page.component.html';
import {AdminListColumn, AdminResourceListPageBase} from '../common/controller/admin-resource-list-page-base';
import {LocalNetworkProfile} from '../../components/session/local-network-profile';

@Component({
  standalone: false,
  selector: 'adn-print-line-item-list-page',
  template
})
export class PrintLineItemListPageComponent extends AdminResourceListPageBase {
  readonly itemStateName = 'app.adv.print-line-items.print-line-item';
  readonly advertiserItemStateName = 'app.adv.advertisers.advertiser';

  readonly columns: AdminListColumn[] = [
    {param: 'name'},
    {param: 'description'},
    {param: 'startDate'},
    {param: 'endDate'},
    {param: 'advertiser', label: 'advertiser'}
  ];

  constructor(@Inject(LocalNetworkProfile) LocalNetworkProfile: any) {
    super(LocalNetworkProfile);
  }
}
